import { createLessonVersion } from "api/services/vr-lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useCreateLessonVersion = () => {
    const { callAPI } = useWorkspaceApiCall(
        createLessonVersion,
        'createLessonVersion.success',
        'createLessonVersion.error'
    );

    return { createLessonVersion: callAPI };
};